'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagSgAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M3.69608e-05 0H28C28 6.66667 28 13.3333 28 20C18.6667 20 9.33334 20 9.66186e-06 20C9.66186e-06 13.3333 -0.000166285 6.66667 3.69608e-05 0Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.66186e-06 10.6667H28V0H3.69608e-05L9.66186e-06 10.6667Z",
          fill: "#E12237"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6.66668 9.33333C7.61179 9.33333 8.48034 9.00556 9.16486 8.45748C8.80225 8.59273 8.40977 8.66667 8.00001 8.66667C6.15906 8.66667 4.66668 7.17428 4.66668 5.33333C4.66668 3.49238 6.15906 2 8.00001 2C8.40976 2 8.80225 2.07393 9.16486 2.20919C8.48034 1.66111 7.61179 1.33333 6.66668 1.33333C4.45754 1.33333 2.66668 3.12419 2.66668 5.33333C2.66668 7.54247 4.45754 9.33333 6.66668 9.33333ZM8.00001 4.66667C8.00001 5.03486 7.70153 5.33333 7.33334 5.33333C6.96515 5.33333 6.66668 5.03486 6.66668 4.66667C6.66668 4.29848 6.96515 4 7.33334 4C7.70153 4 8.00001 4.29848 8.00001 4.66667ZM8.66668 8C9.03487 8 9.33334 7.70152 9.33334 7.33333C9.33334 6.96514 9.03487 6.66667 8.66668 6.66667C8.29849 6.66667 8.00001 6.96514 8.00001 7.33333C8.00001 7.70152 8.29849 8 8.66668 8ZM12 7.33333C12 7.70152 11.7015 8 11.3333 8C10.9652 8 10.6667 7.70152 10.6667 7.33333C10.6667 6.96514 10.9652 6.66667 11.3333 6.66667C11.7015 6.66667 12 6.96514 12 7.33333ZM12.6667 5.33333C13.0349 5.33333 13.3333 5.03486 13.3333 4.66667C13.3333 4.29848 13.0349 4 12.6667 4C12.2985 4 12 4.29848 12 4.66667C12 5.03486 12.2985 5.33333 12.6667 5.33333ZM10.6667 2.66667C10.6667 3.03486 10.3682 3.33333 10 3.33333C9.63182 3.33333 9.33334 3.03486 9.33334 2.66667C9.33334 2.29848 9.63182 2 10 2C10.3682 2 10.6667 2.29848 10.6667 2.66667Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M9.66186e-06 10.6734H0.50001L0.50001 19.5H27.5V10.6734H28V20H9.66186e-06V10.6734Z",
          fill: "#949494"
        }
      )
    ]
  }
);
const VpFlagSgAsset = forwardRef(FlagSgAsset);

export { VpFlagSgAsset as default };
